var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(-948 -650)",
    stroke: "#ff7200"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 0,
    height: 0,
    rx: 5,
    transform: "translate(948 650)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "index",
    d: "M264.777,233.087a.416.416,0,0,1,0,.831h-.286a.144.144,0,0,0-.145.141l-.5,13.173a1.578,1.578,0,0,1-1.565,1.51h-8.866a1.577,1.577,0,0,1-1.566-1.51l-.5-13.173a.147.147,0,0,0-.145-.141h-.286a.416.416,0,0,1,0-.831h3.683a.219.219,0,0,0,.189-.131l.195-.487a1.519,1.519,0,0,1,1.336-.905h3.048a1.516,1.516,0,0,1,1.336.905l.195.487a.22.22,0,0,0,.189.131Zm-7.2,3.6v9.421a.416.416,0,1,0,.831,0v-9.421a.416.416,0,1,0-.831,0Zm-3.186.012.277,9.421a.416.416,0,1,0,.831-.024l-.277-9.421a.416.416,0,1,0-.831.024Zm6.1-.024-.277,9.421a.416.416,0,0,0,.831.024l.277-9.421a.416.416,0,1,0-.831-.024Zm-4.721-3.9-.124.31h4.287a.086.086,0,0,0,.087-.126l-.074-.184a.692.692,0,0,0-.564-.383h-3.048a.7.7,0,0,0-.564.383Z",
    transform: "translate(707.484 427.258)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.e2629f4a56f04e577487f82ef298296f.svg";
export { ForwardRef as ReactComponent };